<template>

<div id="privacy-policy" class="document">

  <Title :text="$t('privacy.title')"/>

  <div class="privacy-date">
    <Common :text="$t('privacy.date')"/>
  </div>

  <Common :text="$t('privacy.paragraph01')"/>

  <Subtitle :text="$t('privacy.section01.title')"/>

  <Common :text="$t('privacy.section01.paragraph01')"/>

  <Ul
    section="privacy-01"
    :items="[
      $t('privacy.section01.bullets.bullet01'),
      $t('privacy.section01.bullets.bullet02')
    ]"/>

  <Subtitle :text="$t('privacy.section02.title')"/>

  <Common :text="$t('privacy.section02.paragraph01')"/>

  <Ul
    section="privacy-02"
    :items="[
      $t('privacy.section02.bullets.bullet01'),
      $t('privacy.section02.bullets.bullet02')
    ]"/>

  <Subtitle :text="$t('privacy.section03.title')"/>

  <Common :text="$t('privacy.section03.paragraph01')"/>

  <Ul
    section="privacy-03"
    :items="[
      $t('privacy.section03.bullets.bullet01'),
      $t('privacy.section03.bullets.bullet02'),
      $t('privacy.section03.bullets.bullet03'),
      $t('privacy.section03.bullets.bullet04')
    ]"/>

  <Subtitle :text="$t('privacy.section04.title')"/>

  <Common :text="$t('privacy.section04.paragraph01')"/>

  <Common :text="$t('privacy.section04.paragraph02')"/>

  <Subtitle :text="$t('privacy.section05.title')"/>

  <Common :text="$t('privacy.section05.paragraph01')"/>

  <Common :text="$t('privacy.section05.paragraph02')"/>

  <Subtitle :text="$t('privacy.section06.title')"/>

  <Common :text="$t('privacy.section06.paragraph01')"/>

  <Ul
    section="privacy-06"
    :items="[
      $t('privacy.section06.bullets.bullet01'),
      $t('privacy.section06.bullets.bullet02'),
      $t('privacy.section06.bullets.bullet03'),
      $t('privacy.section06.bullets.bullet04'),
      $t('privacy.section06.bullets.bullet05'),
      $t('privacy.section06.bullets.bullet06')
    ]"/>

  <Common :text="$t('privacy.section06.paragraph02')"/>

  <Subtitle :text="$t('privacy.section07.title')"/>

  <Common :text="$t('privacy.section07.paragraph01')"/>

  <Common :text="$t('privacy.section07.paragraph02')"/>

  <Subtitle :text="$t('privacy.section08.title')"/>

  <Common :text="$t('privacy.section08.paragraph01')"/>

  <Subtitle :text="$t('privacy.section09.title')"/>

  <Common :text="$t('privacy.section09.paragraph01')"/>

  <Ul
    section="privacy-09"
    :items="[
      $t('privacy.section09.bullets.bullet01'),
      $t('privacy.section09.bullets.bullet02')
    ]"/>

  <Subtitle :text="$t('privacy.section10.title')"/>

  <Common :text="$t('privacy.section10.paragraph01')"/>

  <Subtitle :text="$t('privacy.section11.title')"/>

  <Common :text="$t('privacy.section11.paragraph01')"/>

  <Subtitle :text="$t('privacy.section12.title')"/>

  <Common :text="$t('privacy.section12.paragraph01')"/>

  <Subtitle :text="$t('privacy.section13.title')"/>

  <Common :text="$t('privacy.section13.paragraph01')"/>

</div>

</template>

<script>
import Title from './general/texts/Title.vue'
import Subtitle from './general/texts/Subtitle.vue'
import Common from './general/texts/Common.vue'
import Ul from './general/elements/Ul.vue'

export default {
  name: 'PrivacyPolicy',
  components: {
    Title,
    Subtitle,
    Common,
    Ul
  }
}
</script>

<style lang="scss" scoped>
ul {
  list-style: initial;
  padding-left: 40px;
}

.privacy-date {
  div {
    font-family: 'Poppins-ExtraBold';
    font-weight: bold;
    text-align: center;
  }
}
</style>
